var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-content-manager-search',_vm._b({attrs:{"default-selected":_vm.getDefaultSelected},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'admin-content-manager-search',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }